import { capitalize } from 'helpers/helpers';
import { translateBlock } from 'i18n';

export function concatenateSelectedValues(selectedValues: string[]) {
    return selectedValues
        .map((domain) => capitalize(translateBlock(domain)))
        .join(', ');
}

const TEMPLATE_QUERY_PARAM_KEY = 'from_chart';
const IS_CHART_TEMPLATE = 'is_template';

export function getChartTemplateAdditionnalQueryParams(search: string) {
    const searchParams = new URLSearchParams(search);
    const isTemplate = searchParams.get(IS_CHART_TEMPLATE) === 'true';
    const chartTemplateValue = searchParams.get(TEMPLATE_QUERY_PARAM_KEY);
    // return null if the query param value does not exist
    return {
        isTemplate,
        chartTemplateKey: parseInt(chartTemplateValue || '', 10) || null,
    };
}

function setChartTemplateKeyQueryParamIfExists(
    currentSearch: string,
    value: string | number | null,
) {
    if (!value) return currentSearch;
    return `${currentSearch}&${TEMPLATE_QUERY_PARAM_KEY}=${value}`;
}

export function setChartTemplateAdditionnalQueryParams(
    currentSearch: string,
    value: string | number | null,
    isChartTemplate: boolean,
) {
    return `${setChartTemplateKeyQueryParamIfExists(currentSearch, value)}${
        isChartTemplate ? `&${IS_CHART_TEMPLATE}=true` : ''
    }`;
}

function getValueOrEmpty(text?: string | null) {
    if (text !== undefined && text !== null) return `|${text}`;
    return '';
}
export function getQueryURL(
    filters: QueryFilterT[],
    dimensions: QueryDimensionT[],
    metrics: QueryMetricT[],
) {
    const metricsParams = metrics.map(
        (metric) => `metrics=${metric.field}|${metric.aggregation}`,
    );
    const dimensionsParams = dimensions.map(
        (dimension) =>
            `dimensions=${dimension.field}${getValueOrEmpty(dimension.scale)}`,
    );
    const filtersParams = filters.map(
        (filter) =>
            `filters=${filter.field}|${filter.operation}${getValueOrEmpty(
                filter.valueScale,
            )}${getValueOrEmpty(filter.value)}`,
    );
    return metricsParams.concat(dimensionsParams, filtersParams).join('&');
}
